import m from "../../geodata/es2015/nigeriaHigh";
window.am4geodata_nigeriaHigh = m;


//////////////////
// WEBPACK FOOTER
// ./geodata/nigeriaHigh.js
// module id = null
// module chunks = 